module.exports = __webpack_public_path__ + "1bfb476b3f4a4fe36553ace443c7ee7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pdf-icon.svg
// module id = 160
// module chunks = 0